/* eslint-env browser */

import * as React from 'react'
const ReactDOM = require('react-dom')

const DomHelper = require('../../client/clientjs/dom-helper')
const Ranking = require('./components/Ranking')

require('../../container/client')

DomHelper.onDocumentReady(() => {
  const renderRanking = DomHelper.query('#react-render-team-ranking')
  if (renderRanking) {
    ReactDOM.hydrate(
      <Ranking
        locale={window.initialState.locale.identifierShort}
        ranking={window.initialState.teamRanking}
        fishCatchesByRoundId={window.initialState.teamFishCatchesByRoundId}
        rounds={window.initialState.contestRounds}
      />,
      renderRanking
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
